import GoalAndOperationalPlansDetail from './GoalAndOperationalPlansDetail';

export default GoalAndOperationalPlansDetail;
